import React from 'react'

const Manual_admin_impuestos = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          Admin - Impuestos
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          La guía explica cómo gestionar impuestos en el sistema de manera sencilla, permitiendo crear y editar entradas fácilmente. Detalla los pasos y campos esenciales para una configuración eficiente, ayudando a mantener el cumplimiento y la precisión en los registros financieros.
        </p>
        <iframe
          src="https://scribehow.com/embed/Admin__Impuestos__sKK3a0q6SN2-dT0cOPaPcg?as=scrollable"
          className="scribe-iframe-general-52"
          width="100%"
          height="4500"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_admin_impuestos